if( typeof MediaError === "undefined" ){
  var MediaError = {
    MEDIA_ERR_DECODE: 2,
    MEDIA_ERR_NETWORK: 3,
    MEDIA_ERR_SRC_NOT_SUPPORTED: 4
  };
}

module.exports = MediaError;
